export const financialNumbersDummyData = [
  {
    period: {
      start: '2023-01-01',
      end: '2023-12-31',
    },

    revenue: 87734059321,
    revenue_estimate: 8793000000,
    other_income: 13450000,
    costs: 2015608455,
    gross_result: 8512493476,
    operating_costs: 2179456123,
    other_operating_income: 2350000,
    staff_expenses: 4311983200,
    ebitda: 2021058300,
    depreciation: 1140321421,
    ebit: 880737879,
    interest_income: 212037211,
    interest_expenses: 598724333,
    other_net_financial_income: 7500000,
    net_financial_income: -379186122,
    ordinary_profit: 501551757,
    extraordinary_item: 0,
    profit_loss_before_tax: 501554183,
    tax_expenses: -108423944,
    profit_loss: 393130239,
    goodwill: 0,
    other_intangible_assets: 0,
    intangible_assets: 7583294231,
    land_and_buildings: 1834423778,
    plant_equipment_and_fixtures: 1690342271,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 3524766049,
    noncurrent_receivables: 0,
    noncurrent_investments: 823311259,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 4962124093,
    noncurrent_assets: 11441284373,
    inventories: 38842511,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 412198421,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 5102384534,
    short_term_receivables: 5514582955,
    current_financial_assets: 12398711,
    cash: 208972134,
    current_assets: 5730453799,
    assets: 17171738172,
    contributed_capital: 5482293411,
    reserves: 6578190238,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 1095340000,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 6541101234,
    minority_interests: 0,
    equity: 6541101234,
    untaxed_reserves: null,
    provisions: 132454890,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 715939452,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 198423212,
    other_long_term_debt: 8423981221,
    long_term_debt: 8650344886,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 258453290,
    short_term_tax_payables: 106382112,
    other_short_term_debt: 1102198312,
    short_term_debt: 1469033714,
    debt: 10119378600,
    liabilities_and_equity: 17171738172,
  },

  {
    period: {
      start: '2022-01-01',
      end: '2022-12-31',
    },
    revenue: 90123845723,
    revenue_estimate: 9180000000,
    other_income: 2398123,
    costs: 2058123498,
    gross_result: 8891237401,
    operating_costs: 2348123940,
    staff_expenses: 4192834001,
    ebitda: 2203839463,
    depreciation: 1132849234,
    ebit: 1070980229,
    interest_income: 243981273,
    interest_expenses: 614823934,
    net_financial_income: -370842661,
    ordinary_profit: 699137568,
    tax_expenses: -125349182,
    profit_loss: 573788386,
    goodwill: 213948123,
    intangible_assets: 7843291834,
    land_and_buildings: 1784923812,
    property_plant_and_equipment: 3348191832,
    noncurrent_assets: 11682689979,
    inventories: 4192834,
    short_term_receivables: 5112938482,
    cash: 204812374,
    current_assets: 5369732200,
    assets: 17052422179,
    equity: 6631928374,
    long_term_debt: 8439823421,
    short_term_debt: 1398729843,
    debt: 9838553264,
    liabilities_and_equity: 17052422179,
  },
  {
    period: {
      start: '2021-01-01',
      end: '2021-12-31',
    },
    revenue: 88023375213,
    revenue_estimate: 88910000000,
    other_income: 19345782,
    costs: 19670238412,
    gross_result: 86023958473,
    operating_costs: 21987298344,
    other_operating_income: 1278923,
    staff_expenses: 43329481234,
    ebitda: 20834892345,
    depreciation: 11462394821,
    ebit: 9372497524,
    interest_income: 2178394723,
    interest_expenses: 6072398472,
    other_net_financial_income: 14823981,
    net_financial_income: -3889014768,
    ordinary_profit: 5483482756,
    extraordinary_item: 0,
    profit_loss_before_tax: 5483482756,
    tax_expenses: -1182847123,
    profit_loss: 4300635633,
    goodwill: 182938472,
    intangible_assets: 76423947283,
    land_and_buildings: 18783947238,
    plant_equipment_and_fixtures: 17192384723,
    property_plant_and_equipment: 36028473961,
    noncurrent_investments: 836583472,
    noncurrent_financial_assets: 5079847123,
    noncurrent_assets: 117834239847,
    inventories: 39128472,
    short_term_receivables: 55498347283,
    current_financial_assets: 12793847,
    cash: 2109834723,
    current_assets: 57638423947,
    assets: 175472663794,
    equity: 66438293472,
    long_term_debt: 86483947238,
    short_term_debt: 14992847238,
    debt: 101476794476,
    liabilities_and_equity: 175472663794,
  },
  {
    period: {
      start: '2020-01-01',
      end: '2020-12-31',
    },
    revenue: 89432738412,
    revenue_estimate: 90100000000,
    other_income: 28394712,
    costs: 20039284712,
    gross_result: 87392847192,
    operating_costs: 22847293847,
    staff_expenses: 42938472918,
    ebitda: 21749238471,
    depreciation: 11823984712,
    ebit: 9925243761,
    interest_income: 2439481723,
    interest_expenses: 6183948123,
    net_financial_income: -3744466400,
    ordinary_profit: 618077361,
    tax_expenses: -1123948123,
    profit_loss: 505682148,
    intangible_assets: 78123847123,
    property_plant_and_equipment: 35823984712,
    noncurrent_assets: 118492384712,
    inventories: 38947231,
    short_term_receivables: 54823984712,
    cash: 2239847123,
    current_assets: 57323984712,
    assets: 175816369424,
    equity: 66728394712,
    long_term_debt: 86723984712,
    short_term_debt: 14823984712,
    debt: 101547969424,
    liabilities_and_equity: 175816369424,
  },
  {
    period: {
      start: '2019-01-01',
      end: '2019-12-31',
    },
    revenue: 61640581.135008,
    revenue_estimate: null,
    other_income: 0,
    costs: 1264726.980784,
    gross_result: 60375854.154224,
    operating_costs: 13806415.171416,
    other_operating_income: 0,
    staff_expenses: 28389700.478472,
    ebitda: 18179738.504336,
    depreciation: 9966120.418952,
    ebit: 8213618.085384,
    interest_income: 3995498.1658,
    interest_expenses: 4322296.747216,
    other_net_financial_income: 0,
    net_financial_income: -326798.581416,
    ordinary_profit: 7886819.61956,
    extraordinary_item: 0,
    profit_loss_before_tax: 7886819.61956,
    tax_expenses: -1793358.094784,
    profit_loss: 6093461.524776,
    goodwill: 0,
    other_intangible_assets: 0,
    intangible_assets: 61463747.799856,
    land_and_buildings: 17054710.350744,
    plant_equipment_and_fixtures: 19274414.857344,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 36329125.208088,
    noncurrent_receivables: 4337353.876728,
    noncurrent_investments: -2049021.474992,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 8461639.794064,
    noncurrent_assets: 106254512.802008,
    inventories: 32609.65912,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 3006109.017176,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 1245909.52792,
    short_term_receivables: 4252018.429504,
    current_financial_assets: 83360.211128,
    cash: 16998000.453176,
    current_assets: 21282628.5418,
    assets: 127537141.228216,
    contributed_capital: 44135966.376072,
    reserves: 37289183.695856,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: -6656127.316072,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 37479839.06,
    minority_interests: 0,
    equity: 37479839.06,
    untaxed_reserves: null,
    provisions: 79139.48484,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 5499895.911224,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 800255.784344,
    other_long_term_debt: 72695637.839432,
    long_term_debt: 72774777.324272,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2419359.517088,
    short_term_tax_payables: 1693706.809544,
    other_short_term_debt: 7669562.606088,
    short_term_debt: 17282524.959536,
    debt: 90057302.283808,
    liabilities_and_equity: 127537141.228216,
  },
  {
    period: {
      start: '2018-01-01',
      end: '2018-12-31',
    },
    revenue: 59224213.577375,
    revenue_estimate: null,
    other_income: 0,
    costs: 1206229.369279,
    gross_result: 58017984.208096005,
    operating_costs: 15016207.93156,
    other_operating_income: 0,
    staff_expenses: 27637764.250272002,
    ebitda: 15364012.026264,
    depreciation: 7823975.7574000005,
    ebit: 7540036.268864,
    interest_income: 2324465.882321,
    interest_expenses: 3367950.644806,
    other_net_financial_income: 0,
    net_financial_income: -1043484.879954,
    ordinary_profit: 6496551.38891,
    extraordinary_item: 0,
    profit_loss_before_tax: 6496551.38891,
    tax_expenses: -1546655.8234380002,
    profit_loss: 4949895.565472,
    goodwill: 60031149.017587,
    other_intangible_assets: 0,
    intangible_assets: 61350474.838279,
    land_and_buildings: 5567240.7384440005,
    plant_equipment_and_fixtures: 21056306.268162,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 26623546.889137,
    noncurrent_receivables: 3817618.9226120003,
    noncurrent_investments: 4106542.738287,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 7005115.334184,
    noncurrent_assets: 94979137.0616,
    inventories: 28289.941801,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 3585437.215228,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 1565632.940388,
    short_term_receivables: 5151070.155616,
    current_financial_assets: 43299.778214,
    cash: 7756510.726382,
    current_assets: 12935870.941268,
    assets: 107915008.002868,
    contributed_capital: 44850709.204224,
    reserves: 31703911.044025,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: -12953046.906041,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 31897662.180714,
    minority_interests: 0,
    equity: 31897662.180714,
    untaxed_reserves: null,
    provisions: 58635.473633,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 4183524.285402,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1319325.820692,
    other_long_term_debt: 62251754.566089004,
    long_term_debt: 62310390.039722,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2585707.65827,
    short_term_tax_payables: 1306280.535835,
    other_short_term_debt: 5631443.302925,
    short_term_debt: 13706955.782432001,
    debt: 76017345.822154,
    liabilities_and_equity: 107915008.002868,
  },
  {
    period: {
      start: '2017-01-01',
      end: '2017-12-31',
    },
    revenue: 59960496.595318995,
    revenue_estimate: null,
    other_income: 0,
    costs: 1455727.889857,
    gross_result: 58504768.705461994,
    operating_costs: 17419662.89254,
    other_operating_income: 0,
    staff_expenses: 28622675.734631,
    ebitda: 12462430.078290999,
    depreciation: 7647869.334442,
    ebit: 4814560.743849,
    interest_income: 1408197.576431,
    interest_expenses: 4009579.389809,
    other_net_financial_income: 0,
    net_financial_income: -2601381.8133779997,
    ordinary_profit: 2213178.930471,
    extraordinary_item: 0,
    profit_loss_before_tax: 2213178.930471,
    tax_expenses: -736187.274179,
    profit_loss: 1476991.6562919999,
    goodwill: 62253143.211191,
    other_intangible_assets: 0,
    intangible_assets: 63854588.961899,
    land_and_buildings: 5300127.447627,
    plant_equipment_and_fixtures: 19902371.193602998,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 25202498.519412998,
    noncurrent_receivables: 2656457.9590519997,
    noncurrent_investments: 4258542.396291,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 6396493.847496999,
    noncurrent_assets: 95453581.328809,
    inventories: 23161.675294999997,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 4036731.059122,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 1276409.8549809998,
    short_term_receivables: 5313141.03592,
    current_financial_assets: 80909.755047,
    cash: 4557292.985208999,
    current_assets: 9893595.574607,
    assets: 105347176.903416,
    contributed_capital: 46510814.284031995,
    reserves: 27800967.444686998,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: -18508924.072251,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 28001890.089964,
    minority_interests: 0,
    equity: 28001890.089964,
    untaxed_reserves: null,
    provisions: 12856.56618,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 3135404.883416,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1601445.750708,
    other_long_term_debt: 63895099.936151,
    long_term_debt: 63907956.502330996,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2255958.380897,
    short_term_tax_payables: 422373.891394,
    other_short_term_debt: 7623593.155413999,
    short_term_debt: 13437330.311121,
    debt: 77345286.81345199,
    liabilities_and_equity: 105347176.903416,
  },
  {
    period: {
      start: '2016-01-01',
      end: '2016-12-31',
    },
    revenue: 46723096.514752,
    revenue_estimate: null,
    other_income: 0,
    costs: 1214950.805352,
    gross_result: 45508145.7094,
    operating_costs: 13002851.995928,
    other_operating_income: 0,
    staff_expenses: 22702359.609968,
    ebitda: 9802934.103504,
    depreciation: 7021727.742824,
    ebit: 2781206.36068,
    interest_income: 609873.231424,
    interest_expenses: 5460709.2136,
    other_net_financial_income: 0,
    net_financial_income: -4850835.982176,
    ordinary_profit: -2069629.6214959999,
    extraordinary_item: 0,
    profit_loss_before_tax: -2069629.6214959999,
    tax_expenses: 427972.283416,
    profit_loss: -1641657.33808,
    goodwill: 59170049.611832,
    other_intangible_assets: 0,
    intangible_assets: 60989854.991128,
    land_and_buildings: 5967027.43532,
    plant_equipment_and_fixtures: 19951018.34268,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 25918045.778,
    noncurrent_receivables: 1977058.69252,
    noncurrent_investments: 4095346.07688,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 5106585.817928,
    noncurrent_assets: 92014486.587056,
    inventories: 61267.566736,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 2351428.194216,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 965818.951472,
    short_term_receivables: 3317247.145688,
    current_financial_assets: 0,
    cash: 455569.284032,
    current_assets: 3834083.996456,
    assets: 95848570.583512,
    contributed_capital: 44207361.09868,
    reserves: 25022287.493359998,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: -18994101.675616,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 25213259.423064,
    minority_interests: 0,
    equity: 25213259.423064,
    untaxed_reserves: null,
    provisions: 10884.738056,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 2542722.4665759997,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1819805.3792959999,
    other_long_term_debt: 59653222.496168,
    long_term_debt: 59664107.234224,
    short_term_debt_to_group_enterprises: 4309380.558408,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2131147.51324,
    short_term_tax_payables: 0,
    other_short_term_debt: 1987953.272216,
    short_term_debt: 10971203.81044,
    debt: 70635311.044664,
    liabilities_and_equity: 95848570.467728,
  },
  {
    period: {
      start: '2015-01-01',
      end: '2015-12-31',
    },
    revenue: 47806399.931609,
    revenue_estimate: null,
    other_income: 0,
    costs: 1229966.372692,
    gross_result: 46576433.558917,
    operating_costs: 12852643.398663,
    other_operating_income: 0,
    staff_expenses: 21203028.058255,
    ebitda: 12520762.101999,
    depreciation: 4898645.426887,
    ebit: 7622116.675112,
    interest_income: 21163.936025,
    interest_expenses: 4182582.6483839997,
    other_net_financial_income: 0,
    net_financial_income: -4161418.712359,
    ordinary_profit: 3460697.9627529997,
    extraordinary_item: 0,
    profit_loss_before_tax: 3460697.9627529997,
    tax_expenses: -1038931.8199659999,
    profit_loss: 2421766.142787,
    goodwill: 57839140.804287,
    other_intangible_assets: 0,
    intangible_assets: 59204395.678919,
    land_and_buildings: 4485080.672949,
    plant_equipment_and_fixtures: 8214715.484048,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 12699796.156996999,
    noncurrent_receivables: 647540.850817,
    noncurrent_investments: 4011633.154709,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 4063149.699959,
    noncurrent_assets: 75967341.535875,
    inventories: 39204.288967,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 2207475.75979,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 596024.305567,
    short_term_receivables: 2803500.065357,
    current_financial_assets: 0,
    cash: 6140499.362629,
    current_assets: 8983203.716953,
    assets: 84950545.252828,
    contributed_capital: 238944.543745,
    reserves: 26045034.933548998,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 25992735.993145,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 26231680.53689,
    minority_interests: 0,
    equity: 26231680.53689,
    untaxed_reserves: null,
    provisions: 2437.3747789999998,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 3059011.6058239997,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1365254.874632,
    other_long_term_debt: 46998231.907215,
    long_term_debt: 47000669.281994,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 1470537.718973,
    short_term_tax_payables: 706089.899573,
    other_short_term_debt: 6482556.209574,
    short_term_debt: 11718195.433944,
    debt: 58718864.715938,
    liabilities_and_equity: 84950545.252828,
  },
  {
    period: {
      start: '2013-01-01',
      end: '2013-12-31',
    },
    revenue: 55718268.421563,
    revenue_estimate: null,
    other_income: 0,
    costs: 1565232.166353,
    gross_result: 54153036.255210005,
    operating_costs: 16020548.398056,
    other_operating_income: 0,
    staff_expenses: 26905428.639669,
    ebitda: 11227059.381984001,
    depreciation: 6949049.038284,
    ebit: 4278010.3437,
    interest_income: 352866.311403,
    interest_expenses: 906536.223108,
    other_net_financial_income: 0,
    net_financial_income: -553669.747206,
    ordinary_profit: 3724340.431995,
    extraordinary_item: 0,
    profit_loss_before_tax: 3724340.431995,
    tax_expenses: -1634969.7079140001,
    profit_loss: 2089370.724081,
    goodwill: 0,
    other_intangible_assets: 0,
    intangible_assets: 4758117.454098,
    land_and_buildings: 9160504.669203,
    plant_equipment_and_fixtures: 9849125.612532001,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 19009630.281735,
    noncurrent_receivables: 74888.16975,
    noncurrent_investments: 1640420.875776,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 1833394.9816740002,
    noncurrent_assets: 25601142.717507,
    inventories: 56626.313265000004,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 2604003.542595,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 3240447.212613,
    short_term_receivables: 5844450.755208001,
    current_financial_assets: 118085.93614800001,
    cash: 11606984.462895,
    current_assets: 17508061.531368002,
    assets: 43109204.248875,
    contributed_capital: 2292644.7703650002,
    reserves: 16405751.758380001,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 14349705.899715,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 16642350.67008,
    minority_interests: 0,
    equity: 16642350.67008,
    untaxed_reserves: null,
    provisions: 26448.642717000002,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 2751882.2216310003,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1599536.623314,
    other_long_term_debt: 6237408.92739,
    long_term_debt: 6263857.570107,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2328281.504727,
    short_term_tax_payables: 0,
    other_short_term_debt: 15122832.117831001,
    short_term_debt: 20202995.844189,
    debt: 26466853.414296,
    liabilities_and_equity: 43109204.084376,
  },
  {
    period: {
      start: '2012-01-01',
      end: '2012-12-31',
    },
    revenue: 67057641.83314,
    revenue_estimate: null,
    other_income: 0,
    costs: 1840787.0726,
    gross_result: 65216854.76054,
    operating_costs: 16724080.69402,
    other_operating_income: 0,
    staff_expenses: 26264475.750520002,
    ebitda: 22228298.316,
    depreciation: 6718655.20536,
    ebit: 15509643.11064,
    interest_income: 509300.65508,
    interest_expenses: 1058297.50978,
    other_net_financial_income: 0,
    net_financial_income: -548996.8547,
    ordinary_profit: 14960646.25594,
    extraordinary_item: 0,
    profit_loss_before_tax: 14960646.25594,
    tax_expenses: -4092247.4341,
    profit_loss: 10868398.82184,
    goodwill: 163170.93926,
    other_intangible_assets: 0,
    intangible_assets: 2728292.54614,
    land_and_buildings: 7131367.3608800005,
    plant_equipment_and_fixtures: 11406160.9844,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 18537528.34528,
    noncurrent_receivables: 603520.5057,
    noncurrent_investments: 9831524.58946,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 9913296.59446,
    noncurrent_assets: 31179117.48588,
    inventories: 12466.70572,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 2675407.38878,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 603520.5057,
    short_term_receivables: 3278927.8944800003,
    current_financial_assets: 0,
    cash: 24817207.89758,
    current_assets: 28108602.49778,
    assets: 59287719.98366,
    contributed_capital: 2503388.1887,
    reserves: 19090308.35642,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 16845267.61372,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 19348655.80242,
    minority_interests: 0,
    equity: 19348655.80242,
    untaxed_reserves: null,
    provisions: 1191437.422,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 2767711.41248,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 2565121.60688,
    other_long_term_debt: 7774364.21132,
    long_term_debt: 8965801.63332,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 3296948.4506,
    short_term_tax_payables: 0,
    other_short_term_debt: 24908602.86446,
    short_term_debt: 30973262.72754,
    debt: 39939064.36086,
    liabilities_and_equity: 59287720.16328,
  },
  {
    period: {
      start: '2011-01-01',
      end: '2011-12-31',
    },
    revenue: 64768668.191640005,
    revenue_estimate: null,
    other_income: 0,
    costs: 1593227.089755,
    gross_result: 63175441.101885006,
    operating_costs: 12940965.6915,
    other_operating_income: 0,
    staff_expenses: 26807820.69021,
    ebitda: 23426654.720175,
    depreciation: 5787416.834955,
    ebit: 17639237.885220002,
    interest_income: -1256031.75096,
    interest_expenses: 0,
    other_net_financial_income: -1985897.38473,
    net_financial_income: -1256031.75096,
    ordinary_profit: 16383206.13426,
    extraordinary_item: 0,
    profit_loss_before_tax: 16383206.13426,
    tax_expenses: -4657345.890435,
    profit_loss: 11725860.243825,
    goodwill: 878509.50222,
    other_intangible_assets: 0,
    intangible_assets: 2638922.228985,
    land_and_buildings: 6849824.156385001,
    plant_equipment_and_fixtures: 13920449.91792,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 20770274.074305,
    noncurrent_receivables: 11287284.9054,
    noncurrent_investments: 1665909.88032,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 11960745.420750001,
    noncurrent_assets: 35369941.72404,
    inventories: 55571.51397,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 2753450.125335,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 1089078.3204,
    short_term_receivables: 3842528.445735,
    current_financial_assets: 0,
    cash: 19316445.528135,
    current_assets: 23214545.48784,
    assets: 58584487.211880006,
    contributed_capital: 2328268.087425,
    reserves: 27933347.571675003,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 25845354.690750003,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 28173622.778175,
    minority_interests: 0,
    equity: 28173622.778175,
    untaxed_reserves: null,
    provisions: 1491554.2427100001,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 0,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1760412.726765,
    other_long_term_debt: 9392177.402685,
    long_term_debt: 10883731.645395001,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 1611885.1285950001,
    short_term_tax_payables: 3511760.213955,
    other_short_term_debt: 14403486.77754,
    short_term_debt: 19527132.12009,
    debt: 30410863.765485,
    liabilities_and_equity: 58584486.54366,
  },
  {
    period: {
      start: '2010-01-01',
      end: '2010-12-31',
    },
    revenue: 69350615.16741401,
    revenue_estimate: null,
    other_income: 0,
    costs: 1883939.349509,
    gross_result: 67466675.81790501,
    operating_costs: 14804217.201746,
    other_operating_income: 0,
    staff_expenses: 24854885.905101,
    ebitda: 27807572.711058002,
    depreciation: 5313620.206713,
    ebit: 22493952.504345,
    interest_income: 301172.812178,
    interest_expenses: 54298.085975,
    other_net_financial_income: 0,
    net_financial_income: 246874.726203,
    ordinary_profit: 22740827.230548,
    extraordinary_item: 0,
    profit_loss_before_tax: 22740827.230548,
    tax_expenses: -6607284.210828001,
    profit_loss: 16133543.019720001,
    goodwill: 1647100.448847,
    other_intangible_assets: 0,
    intangible_assets: 3369313.178539,
    land_and_buildings: 4375489.836445,
    plant_equipment_and_fixtures: 3318787.633245,
    other_property_plant_and_equipment: 0,
    property_plant_and_equipment: 7694277.469690001,
    noncurrent_receivables: 1044953.487522,
    noncurrent_investments: 1709328.943616,
    other_noncurrent_financial_assets: 0,
    noncurrent_financial_assets: 1789380.2033870001,
    noncurrent_assets: 12852970.851616,
    inventories: 41484.234771,
    current_prepayments: null,
    short_term_receivables_from_sales_and_services: 5590005.220583,
    short_term_receivables_from_group_enterprises: 0,
    other_short_term_receivables: 1044953.487522,
    short_term_receivables: 6634958.708105001,
    current_financial_assets: 0,
    cash: 23188001.772292,
    current_assets: 29864444.715168,
    assets: 42717415.566784,
    contributed_capital: 2388950.373215,
    reserves: 19420124.615955,
    share_premium_account: null,
    restricted_equity: null,
    dividend: 0,
    retained_earnings: 17277711.80744,
    equity_adjustment_items: null,
    unrestricted_equity: null,
    equity_before_minority_interests: 19666662.180655,
    minority_interests: 0,
    equity: 19666662.180655,
    untaxed_reserves: null,
    provisions: 1491640.7134790001,
    long_term_debt_to_group_enterprises: 0,
    long_term_debt_to_banks: 0,
    long_term_mortgage_debt: null,
    equity_loan: 0,
    deferred_tax: 1722212.729692,
    other_long_term_debt: 0,
    long_term_debt: 1491640.7134790001,
    short_term_debt_to_group_enterprises: 0,
    short_term_debt_to_banks: 0,
    short_term_mortgage_debt: null,
    short_term_trade_payables: 2059196.824377,
    short_term_tax_payables: 5397227.689007,
    other_short_term_debt: 14102688.159266,
    short_term_debt: 21559112.672650002,
    debt: 23050753.386129,
    liabilities_and_equity: 42717415.566784,
  },
  {
    period: {
      start: '2009-01-01',
      end: '2009-12-31',
    },
    error: 'We only support dates back to 2010-12-31',
  },
  {
    period: {
      start: '2008-01-01',
      end: '2008-12-31',
    },
    error: 'We only support dates back to 2010-12-31',
  },
]
